var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7852 6.11109L13.6572 7.21109L15.7212 9.22509H7.58516V10.7811H15.7212L13.6572 12.7881L14.7852 13.8891L18.7852 10.0001L14.7852 6.11109ZM4.38516 4.55609H10.7852V3.00009H4.38516C3.96702 2.99554 3.56407 3.15662 3.26429 3.44815C2.96451 3.73969 2.79226 4.13799 2.78516 4.55609V15.4441C2.79226 15.8622 2.96451 16.2605 3.26429 16.552C3.56407 16.8436 3.96702 17.0046 4.38516 17.0001H10.7852V15.4441H4.38516V4.55609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.eec05e2b8e930445e0762df30b3375a7.svg";
export { ForwardRef as ReactComponent };